<template>
  <div class="content">
    <div
      v-if="data.videoFiles.length > 0"
      v-html="data.videoFiles[0].videoPath"
    ></div>
    <template v-else>
      <div
        class="carousel"
        v-if="
          data.imageType === 2 &&
          data.imageFiles != null &&
          data.imageFiles.length > 1
        "
      >
        <a-carousel arrows>
          <template #prevArrow>
            <div class="custom-slick-arrow" style="left: 10px; z-index: 1">
              <left-circle-outlined />
            </div>
          </template>
          <template #nextArrow>
            <div class="custom-slick-arrow" style="right: 10px">
              <right-circle-outlined />
            </div>
          </template>
          <div
            v-for="file in data.imageFiles"
            :key="file.fileId"
            class="carousel_img_wrapper"
          >
            <img
              :src="file.filePath"
              alt="文章圖片"
              :style="{
                width: '100%',
              }"
            />
          </div>
        </a-carousel>
      </div>

      <div class="img" v-else-if="data.imageFiles != null">
        <div
          class="single_img"
          v-for="file in data.imageFiles"
          :key="file.fileId"
        >
          <img :src="file.filePath" alt="文章搭配圖片" />
          <p>{{ file.fileDes }}</p>
        </div>
        <div
          v-if="data.imageFiles.length % 2 && data.imageFiles.length !== 1"
          class="single_img"
        ></div>
      </div>
    </template>
    <div class="content_words" v-html="data.pageContent"></div>
  </div>
</template>

<script>
import { useRoute } from "vue-router";
import { LeftCircleOutlined, RightCircleOutlined } from "@ant-design/icons-vue";

export default {
  name: "Content",
  props: {
    data: {
      required: true,
    },
  },
  components: {
    LeftCircleOutlined,
    RightCircleOutlined,
  },
  setup(props) {
    const route = useRoute();
    const pageId = route.params.pageId;

    return { pageId };
  },
};
</script>

<style lang="scss" scoped>
.content {
  display: flex;
  flex-direction: column;
  align-items: center;

  .img {
    display: flex;
    justify-content: space-around;
    overflow: hidden;
    flex-wrap: wrap;
    width: 100%;

    .single_img {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      width: 49%;
      margin-bottom: 40px;

      @include md {
        width: 100%;
      }

      p {
        text-align: left;
      }
    }
  }

  .content_words {
    margin-top: 20px;
    width: 70%;
    text-align: initial;
    font-size: $h5;
    white-space: pre-wrap;
  }
}

.carousel {
  width: 100%;
  max-width: 560px;

  .ant-carousel :deep(.slick-slide) {
    text-align: center;
    overflow: hidden;
    // background: #024d73;
  }

  .ant-carousel :deep(.slick-arrow.custom-slick-arrow) {
    width: 60px;
    height: 60px;
    font-size: 60px;
    color: #fff;
    background-color: rgba(31, 45, 61, 0.11);
    opacity: 0.3;
    z-index: 3;
  }
  .ant-carousel :deep(.custom-slick-arrow:before) {
    display: none;
  }
  .ant-carousel :deep(.custom-slick-arrow:hover) {
    opacity: 0.5;
  }

  .ant-carousel :deep(.slick-slide h3) {
    color: #fff;
  }

  .carousel_img_wrapper {
    // display: flex;
    text-align: center;
  }
}
</style>
